import router from "./../routes/router";
import store from "@/store/store";
const commonMixin = {
  created() {
  },
  methods: {
    getArraysIntersection(a1, a2) {
      return a1.filter(function (n) { return a2.indexOf(n) !== -1; });
    },
    goBack() {
      if (this.$snotify.notifications.length > 0) {
        this.$snotify.notifications.forEach(notification => {
          this.$snotify.remove(notification.id)
        });
      }
      window.history.back();
    },
    ammendString(type) {
      if (type) {
        return "Amended";
      } else {
        return "Non-Amended";
      }
    },
    getMonthNameFormValue(val) {
      const monthNames = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"];
      return monthNames[val - 1];
    },
    claimStatusString(status) {
      if (status == 1) {
        return "Created";
      } else if (status == 2) {
        return "Assigned";
      } else if (status == 3) {
        return "Work In Progress";
      } else if (status == 4) {
        return "Accountant";
      } else if (status == 5) {
        return "Government";
      }
    },
    getFileExtImg(ext) {
      if (ext == "DOC" || ext == ".DOC" || ext == ".docx") {
        return '<i class="fa-regular fa-file-word fa-2x blue-font"></i>';
      } else if (ext == "PDF" || ext == ".PDF" || ext == ".pdf") {
        return '<i class="fa-solid fa-file-pdf fa-2x red-font"></i>';
      } else if (ext == "CSV" || ext == ".CSV" || ext == ".csv") {
        return '<i class="fa-solid fa-file-csv fa-2x red-font"></i>';
      } else if (ext == "EXCEL" || ext == ".EXCEL" || ext == ".xlsx") {
        return '<i class="fas fa-file-excel fa-2x green-font"></i>';
      } else {
        return '<i class="fas fa-file fa-2x blue-font"></i>';
      }
    },
    redirectToClaimwizard() {
      router.push({
        name: "claimwizard"
      });
    },
    multiFileUploadString(rowData) {
      let fileStr = [];
      if (rowData.isUploaded && !rowData.isArchived) {
        for (let fileCount = 1; fileCount <= 5; fileCount++) {
          if (rowData['fileName_' + fileCount]) {
            fileStr.push(rowData['fileName_' + fileCount]);
          }
        }
      }
      if (fileStr.length) {
        return fileStr.join(', ');
      } else {
        return "N/A";
      }
    },
    truncateText(text) {
      return this.$options.filters.truncate(text, 60, "...");
    }
  }
}

export default commonMixin